'use client'

import type { ProductSliderProps } from '@maestro/commerce-blocks/components/product-slider/product-slider.types'

import { useMemo } from 'react'

import { ProductCard } from '@maestro/commerce-blocks/components/product-card'
import { useProductSlider } from '@maestro/commerce-blocks/components/product-slider/batons/use-product-slider'
import { useManyProductsPrice } from '@maestro/commerce-blocks/hooks/use-many-products-price'
import { useManyProductsStock } from '@maestro/commerce-blocks/hooks/use-many-products-stock'
import { TriggeredFrom } from '@maestro/data-layer'
import { Carousel } from '@pearlconvert/ui/components/carousel'

export default function ProductSlider(props: ProductSliderProps) {
  const {
    products: productsProps,
    enableLazyLoading,
    showWishlistButton,
    addToCartType,
    displayStockStatus,
    enableClientSideStockFetching,
    displayPrice,
    enableClientSidePriceFetching,
    eventListProps,
    eventSearchProps,
    recommendationProps: { trackNavClick, trackSlotClick, productSlotMap } = {},
    carouselName,
  } = props
  const { products: productsWithStock, isLoading: isStockLoading } =
    useManyProductsStock(
      productsProps,
      displayStockStatus && enableClientSideStockFetching,
      eventListProps?.listType
    )
  const { products } = useManyProductsPrice({
    serverProducts: productsWithStock,
    fetchPriceClientSide: displayPrice && enableClientSidePriceFetching,
    listingType: eventListProps?.listType,
  })

  const { containerRef } = useProductSlider(products, eventListProps)

  const carouselKey = useMemo(() => {
    return products.map((p) => p.id).join('-')
  }, [products])

  return (
    <div ref={containerRef}>
      <Carousel
        key={carouselKey}
        name={carouselName}
        recommendationProps={{
          trackNavClick,
        }}
        snapToGrid
      >
        {products.map((product, idx) => (
          <div
            key={`${product.id}-carousel`}
            data-product-id={product.id}
            style={{ display: 'contents' }}
          >
            <ProductCard
              product={product}
              enableLazyLoading={enableLazyLoading}
              showWishlistButton={showWishlistButton}
              addToCartType={addToCartType}
              displayStockStatus={displayStockStatus}
              isStockLoading={isStockLoading}
              displayPrice={displayPrice}
              titleTag="h3"
              eventProps={{
                productIndex: idx + 1,
                eventListProps,
                eventSearchProps,
                triggeredFrom: TriggeredFrom.CAROUSEL,
              }}
              recommendationProps={{
                trackSlotClick,
                productSlotMap,
              }}
            />
          </div>
        ))}
      </Carousel>
    </div>
  )
}
